import styled from "styled-components"

import { memo, useCallback } from "react"
import clsx from "clsx"
import Button from "components/EvtKit/button/Button"
import { Step } from "constants/firstSteps"
import { IconCheckGreen } from "../icons/FirstSteps/IconCheck"
import Heading from "components/Typography/Heading"
import BodyText from "components/Typography/BodyText"
import { contentSections } from "../ListContentHome/ListContent"

const FirstStepCard = styled.div`
  position: relative;
  max-width: 300px;
  min-height: 430px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  border: 1px solid #968ef8;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  opacity: 0.5;

  &.enabled {
    opacity: 1;
    box-shadow: 0px 1px 20px 0px ${(props) => props.theme.palette.card_shadow};
  }

  &.enabled:hover {
    max-width: 320px;
  }

  &.enabled:hover .card-title-text {
    font-size: 24px;
    line-height: 26px;
  }

  .card-title-text,
  .icon-check-green {
    transition: all 0.3s ease-in-out;
  }

  &.completed:hover .icon-check-green {
    width: 22px;
    height: 22px;
  }
`

const FirstStepCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 1;
`

const CardTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`

const LearnMore = styled.a`
  width: fit-content;
`

const StyledButton = styled(Button)`
  z-index: 1;
`

export interface FirstStepCardProps extends Step {
  completed: boolean
  loading?: boolean
  onButtonClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  setIsOpen?: React.Dispatch<React.SetStateAction<contentSections>>
  disabled: boolean
}

const FirstStepsCard = (props: FirstStepCardProps) => {
  const {
    title,
    description,
    learnMore,
    buttonIcon,
    buttonText,
    backgroundIcon,
    disabled,
    loading,
    completed,
    onButtonClick,
    setIsOpen
  } = props

  const isDisabled = disabled && !completed

  const handleLearnMoreClick = useCallback(() => {
    if (!learnMore || !setIsOpen) return

    setIsOpen((prevState) => ({
      ...prevState,
      [learnMore]: true
    }))
  }, [setIsOpen, learnMore])

  return (
    <FirstStepCard className={clsx({ enabled: !isDisabled, completed })}>
      <FirstStepCardContent>
        <CardTitle className="card-title">
          {completed && <IconCheckGreen />}
          <Heading variant="h5" color="primary_alt_medium" className="card-title-text">
            {title}
          </Heading>
        </CardTitle>
        <BodyText color="gray-dark" size="semi-medium">
          {description}
        </BodyText>
        {learnMore && (
          <LearnMore href={"home#" + learnMore} onClick={handleLearnMoreClick}>
            <BodyText color="gray-dark" size="medium" link>
              Saiba mais
            </BodyText>
          </LearnMore>
        )}
      </FirstStepCardContent>
      {backgroundIcon}
      <StyledButton
        onClick={onButtonClick}
        label={buttonText}
        iconLeft={buttonIcon}
        disabled={disabled || loading}
        loading={loading}
        isSmall
      />
    </FirstStepCard>
  )
}

export default memo(FirstStepsCard)
